import { render, staticRenderFns } from "./BracketsStatusesMap.vue?vue&type=template&id=4fcccb18"
import script from "./BracketsStatusesMap.vue?vue&type=script&lang=js"
export * from "./BracketsStatusesMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports